import { Helmet } from 'react-helmet-async';
import React from 'react';
import UserFormContainer from '../../../containers/organizations/UserFormContainer.jsx';
import requireAuth from '../../../lib/requireAuth.jsx';
import withRouterParams from '../../../lib/withRouterParams.jsx';

const NewUser = ({ slug }) => (
  <>
    <Helmet>
      <title>Add User | ChangeSync</title>
    </Helmet>

    <UserFormContainer slug={slug} />
  </>
);

NewUser.getInitialProps = ({ query }) => ({
  slug: query.slug,
});

export default requireAuth(withRouterParams(NewUser));
